// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { GameDataHandler } from '../GameDataHandler';
/* END-USER-IMPORTS */

export default class EarnedPointsTotal extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 161.5, y ?? 59.5);

    // holder_large_png
    const holder_large_png = scene.add.image(0, 0, "common", "holder-large.png");
    this.add(holder_large_png);

    // earnedPointTotal
    const earnedPointTotal = scene.add.text(50, 2, "", {});
    earnedPointTotal.setOrigin(0.5, 0.5);
    earnedPointTotal.text = "0";
    earnedPointTotal.setStyle({ "align": "center", "fixedWidth":175,"fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "52px" });
    earnedPointTotal.setPadding({"left":5,"right":5});
    this.add(earnedPointTotal);

    // icon_note_pile_png
    const icon_note_pile_png = scene.add.image(-88, -5, "common", "icon-note-pile.png");
    icon_note_pile_png.scaleX = 0.75;
    icon_note_pile_png.scaleY = 0.75;
    this.add(icon_note_pile_png);

    this.earnedPointTotal = earnedPointTotal;
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */

    /* END-USER-CTR-CODE */
  }

  private earnedPointTotal: Phaser.GameObjects.Text;
  public showLiveTotal: boolean = true;
  public currentPoints: number = 0;

  /* START-USER-CODE */

  public awake() {
    if (this.showLiveTotal) {
      this.scene.game.registry.events.on(GameDataHandler.events.ChangeEarnedPoints, this.onPointsChange, this);
      this.on(
        Phaser.GameObjects.Events.DESTROY,
        () => {
          this.scene.game.registry.events.off(GameDataHandler.events.ChangeEarnedPoints, this.onPointsChange, this);
        },
        this
      );
    }

    this.updatePoints(this.scene.game.registry.get(GameDataHandler.keys.EarnedPoints));
  }

  public setTotal(totalPoints: number) {
    this.updatePoints(totalPoints);
  }

  public tickToNewTotal(newTotal: number, duration: number, delay: number) {
    let totalTween = this.scene.tweens.addCounter({
      from: this.currentPoints,
      to: newTotal,
      duration: duration,
      ease: Phaser.Math.Easing.Linear,
      delay: delay,
      onUpdate: (tween, target, param) => {
        this.updatePoints(Math.floor(totalTween.getValue()));
      }
    });
  }

  protected onPointsChange(parent: any, value: any, previousValue: any) {
    if (!this.showLiveTotal) return;

    // this.updatePoints(value);
    this.tickToNewTotal(value, 500,  0);
  }

  protected updatePoints(newValue: number) {
    this.currentPoints = newValue;
    this.earnedPointTotal.text = this.currentPoints.toString();
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
